import disputeEvidenceBestPracticesMd from '../../../assets/legal-documents/dispute-evidence-best-practices.md?raw';
import { emphasizeDocumentEnumTokens } from './documentEnumTokens';

export type DisputeEvidenceBestPracticesConfig = {
  slug: string;
  title: string;
  fileName: string;
  content: string;
  introduction: string;
  lastUpdated: string;
  description?: string;
};

const extractIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const introLines: string[] = [];
  let foundTitle = false;
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('# ')) {
      foundTitle = true;
      continue;
    }

    if (line.startsWith('## ') && foundTitle) {
      foundFirstH2 = true;
      break;
    }

    if (foundTitle && !foundFirstH2) {
      if (!line.includes('**Last Updated:**') && line.trim()) {
        introLines.push(line);
      }
    }
  }

  return introLines.join('\n').trim();
};

const removeIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const contentLines: string[] = [];
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('## ')) {
      foundFirstH2 = true;
    }

    if (foundFirstH2) {
      contentLines.push(line);
    }
  }

  return contentLines.join('\n').trim();
};

export const DISPUTE_EVIDENCE_BEST_PRACTICES: DisputeEvidenceBestPracticesConfig = {
  slug: 'dispute-evidence-best-practices',
  title: 'Dispute Evidence Best Practices',
  fileName: 'dispute-evidence-best-practices.md',
  content: emphasizeDocumentEnumTokens(removeIntroduction(disputeEvidenceBestPracticesMd)),
  introduction: extractIntroduction(disputeEvidenceBestPracticesMd),
  lastUpdated: '2026-06-15',
  description: 'Best practices for building a strong dispute response on Bhutan Payments',
};

export const getDisputeEvidenceBestPractices = (): DisputeEvidenceBestPracticesConfig => {
  return DISPUTE_EVIDENCE_BEST_PRACTICES;
};
